//our root app component
import { Component, Directive, Output, EventEmitter, Input, HostListener, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

export interface InputMaskMessage {
  error: boolean,
  message: string,
  dateString: string  
}

/* ej html
<input name="fechaPrueba" type="text" inputDateForm [(ngModel)]="data" (stateInput)="stateInput=$event" [validateMaxCurrentDate]="true" [minDate]="minDateTest"> 
*/

@Directive({
  selector: '[ngModel][inputDateForm]',
  host: {
    '(ngModelChange)': 'onInputChange($event)',
    '(keydown.backspace)': 'onInputChange($event.target.value, true)'
  }
})
export class DateInputMaskFormsDirectiva {

  @Input('validateMaxCurrentDate') 
  validateMaxCurrentDate: boolean = false;
  @Input('minDate') 
  minDate: Date;
  @Input('requiredDate')
  requiredDate: boolean = false;
  @Input('separator')
  separator: string = "-";
  
  @Output('stateInput') 
  stateInput: EventEmitter<InputMaskMessage> = new EventEmitter<InputMaskMessage>();
   
  constructor(
    private el: ElementRef,
    public model: NgControl
  ) {
    //this.el.nativeElement.placeholder = `aaaa${this.separator}MM${this.separator}dd`;
  }  

  @HostListener('input') onInput(event) {
    const length = this.el.nativeElement.value ? this.el.nativeElement.value.length : 0;
    if (length > 10)
      this.el.nativeElement.value = this.el.nativeElement.value.substr(0, length - 1);
  }

  @HostListener("blur", ["$event.target.value"]) onBlur(value) {
    const values = value.split(this.separator);
    if (!values) return;
    if (values[0] && values[0].length < 4) values[0] = this.padValue(values[0], 4);    
    if (values[1] && values[1].length < 2) values[1] = this.padValue(values[1], 2);
    if (values[2] && values[2].length < 2) values[2] = this.padValue(values[2], 2);
    this.model.valueAccessor.writeValue(values.join('-'));
  }
  
  onInputChange(event, backspace) {   
    // remove all mask characters (keep only numeric)
    var newVal = event.replace(/\D/g, '');
    var rawValue = newVal;
    // special handling of backspace necessary otherwise
    // deleting of non-numeric characters is not recognized
    // this laves room for improvment for example if you delete in the 
    // middle of the string
    if (backspace) 
      newVal = newVal.substring(0, newVal.length - 1);    

    // don't show braces for empty value
    if (newVal.length == 0)
      newVal = '';
    else if (newVal.length <= 2) // don't show braces for empty groups at the end    
      newVal = newVal.replace(/^([0-9]{0,4})/, `$1${this.separator}`);
    else if (newVal.length <= 4)
      newVal = newVal.replace(/^([0-9]{0,4})([0-9]{0,2})/, `$1${this.separator}$2${this.separator}`);
    else 
      newVal = newVal.replace(/^([0-9]{0,4})([0-9]{0,2})([0-9]{0,2})/, `$1${this.separator}$2${this.separator}$3`);      

    // set the new value
    this.model.valueAccessor.writeValue(newVal);      
    this.validateDate(newVal);
  } 

  //Function to validate date
  private validateDate(value: string) {

    let foundError = false;
    let values = value.split(this.separator);
    let message = null;

    //year          
    let year = Number(values[0]);
    //month           
    let month = Number(values[1]);

    if (!value && this.requiredDate) {
      foundError = true;
      message = "Ingrese la fecha de pago";
    } else {
      if (!value && !this.requiredDate) {
        foundError = false;
        message = null;
        values = null;
      }
    }


    if (values) {
      //======== VALIDATE YEAR ========
      //validate max current year    
      if (this.validateMaxCurrentDate) {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        if (!year || (year < 1 || year > currentYear)) {
          foundError = true;
          message = "El año no puede ser mayor al año actual";
        } else message = null;
      }

      //if year not contain 4 digit      
      if (values[0].length < 4) {
        foundError = true;  
        message = message || "El año no es valido";
      }        

      //======== VALIDATE MONTH ========
      if (!month || (month < 1 || month > 12)) {
        foundError = true;
        message = message || "El mes no es valido";
      } else message = null;
      
      //======== VALIDATE DAY ========
      if (values.length === 3) {           
        let day = Number(values[2]);
        if (day < 1 || day > this.getDaysByMonth(values[1], values[0])) {
          foundError = true;                
          message = message || "El día no es valido"
        }
      } else foundError = true;

      //======== VALIDATE MIN DATE ========
      if (this.minDate) {
        let minYear = this.minDate.getFullYear();
        let minMonth = this.minDate.getMonth() + 1;
        let minDay = this.minDate.getDate();

        if (year < minYear) {
          foundError = true;  
          message = message || `El año no puede ser menor al ${minYear}`;
        }

        if (month < minMonth) {
          foundError = true;  
          message = message || `El mes no puede ser menor al ${minMonth}`;
        } else if (month === minMonth) {
          if (values.length === 3) {           
            let day = Number(values[2]);
            if (day < minDay) {
              foundError = true;  
              message = message || `El día no puede ser menor al ${minDay}`;
            }
          } 
        }              
      }  
    }
    
    //EMIT MESSAGE
    if (foundError) {
      this.stateInput.emit({
        error: true,
        message: message,
        dateString: null
      });
      this.el.nativeElement.style.border = '1px solid red';
    } else {
      this.stateInput.emit({
        error: false,
        message: message,
        dateString: value
      });
      this.el.nativeElement.style.border = '';
    }
  }

  //Get days on month
  private getDaysByMonth(month: string, year: string) {
    return new Date(Number(year), Number(month), 0).getDate();
  }

  //Pad value left
  private padValue(value: string, width: number, characterFill?: string) {
    characterFill = characterFill || '0';
    value = value + '';
    return value.length >= width ? value : new Array(width - value.length + 1).join(characterFill) + value;
  }

}


// WEBPACK FOOTER //
// D:/github/490/rec_ng_recibopago490v7/src/app/configuracion/date-input-mask.directive.ts